<template>
  <div>
    <slot></slot>
    <el-card class="box-card">
      <div
        slot="header"
        class="clearfix"
      >
        <el-select
          v-model="ConsumptionType"
          clearable
          placeholder="选择消费类型"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-date-picker
          v-model="time"
          style="margin:0 10px;"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="selectTime"
        >
        </el-date-picker>
        <el-button
          id="clearBtn"
          @click="clear"
        >重置</el-button>
        <el-button
          type="primary"
          id="searchBtn"
          @click="getMoney"
        >查询</el-button>
      </div>
      <div>
        <el-table
          :data="tableData"
          style="width: 100%"
          :header-cell-style="tableHeaderColor"
          :default-sort="{prop: 'date', order: 'descending'}"
        >
          <el-table-column
            prop="id"
            label="ID"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="money"
            label="变动金额"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="before"
            label="变动前余额"
          >
          </el-table-column>
          <el-table-column
            prop="after"
            label="变动后余额"
          >
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="变动类型"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.type=='0'">充值</span>
              <span v-if="scope.row.type=='1'">购买接口</span>
              <span v-if="scope.row.type=='2'">购买套餐</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="变动时间"
          >
          </el-table-column>
          <el-table-column
            prop="remark"
            label="备注"
          >
          </el-table-column>
        </el-table>
        <div class="pager">
          <el-pagination
            background
            :page-size="pagesize"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :total="totalcount"
          >
          </el-pagination>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import apis from "@/api/apis";
export default {
  name: 'detailed',

  data () {
    return {
      ConsumptionType: '',
      time: '',
      date: '',
      pagesize: 10,
      pagenum: 1,
      startTime: '',
      endTime: '',
      totalcount: 0,
      tableData: [],
      options: [{
        value: '0',
        label: '充值'
      }, {
        value: '1',
        label: '购买接口'
      }, {
        value: '2',
        label: '购买套餐'
      },]
    };
  },

  mounted () {
    this.getMoney()

  },

  methods: {
    handleCurrentChange (val) {
      this.pagenum = val
      this.getMoney()
    },
    //明细
    getMoney () {
      console.log(this.endTime, "this.startTime");
      apis.index.moneyLog({
        start_time: this.startTime,
        end_time: this.endTime,
        type: this.ConsumptionType,
        page: this.pagenum,
        page_size: this.pagesize
      }).then(res => {

        this.tableData = res.data.list
        this.totalcount = parseInt(res.data.count)
      })
      document.getElementById("searchBtn").blur()
    },
    //重置
    clear () {
      this.startTime = []
      this.endTime = []
      this.time = []
      this.ConsumptionType = []
      this.getMoney()
      document.getElementById("clearBtn").blur()
    },
    //选择时间
    selectTime () {
      this.startTime = this.filterTime(this.time[0])
      this.endTime = this.filterTime(this.time[1])
    },
    //中国标准时间转换格式
    filterTime (time) {
      var date = new Date(time);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      var s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + s;
    },
    tableHeaderColor ({ rowIndex, }) {
      if (rowIndex === 0) {
        return 'background-color: #FAFAFA;color: #000;font-weight: 500;'
      }
    }

  }
}
</script>
<style lang="scss" scoped>
.box-card {
  padding: 10px;
  background: #ffffff;

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: '';
  }
  .clearfix:after {
    clear: both;
  }
  .pager {
    margin-top: 10px;
    width: 100%;
    height: 64px;
    background: #ffffff;
    padding-right: 30px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
</style>